document.addEventListener("DOMContentLoaded", (event) => {
  // console. log("%c Dom Loaded", "color:green; background-color: orange;");
  if(document.querySelector(".readmore-btn")){
    document.querySelector(".readmore-btn").addEventListener("click", function() {
          this.parentElement.classList.toggle('open');
          const buttonText = this.parentElement.classList.contains('open') ? 'Read less' : 'Read more';
          this.textContent = buttonText;
    });
  }
  if(document.querySelector(".show-hide-pass")){
      document.querySelector(".show-hide-pass").addEventListener("click", function() {
        Showpassword(this);
      });        
  }
 
  // =================================================================================
});
$(document).ready(function() {
// =======================================BLog page and blog post page load more button ===============================================================
    $(function() {
      $(".template-blog .m-widget__content_tags li.m-link-lists--item, .template-article .m-widget__content_tags li.m-link-lists--item ").slice(0, 10).css("display", "block");
      $(document).on('click', '.template-blog .m-widget__content_tags .load_more_btn, .template-article .m-widget__content_tags .load_more_btn', function (e) {
          e.preventDefault();
          $(".template-blog .m-widget__content_tags li.m-link-lists--item:hidden, .template-article .m-widget__content_tags li.m-link-lists--item:hidden ").slice(0, 20).slideDown();
          if ($(".template-blog .m-widget__content_tags li.m-link-lists--item:hidden, .template-article .m-widget__content_tags li.m-link-lists--item:hidden ").length === 0) {
              $(".template-blog .m-widget__content_tags .load_more_btn, .template-article .m-widget__content_tags .load_more_btn").css('visibility', 'hidden');
          }
        //  $('html,body').animate({
        //     scrollTop: $(this).offset().top / 2 
        // }, 1000);
      });
    });

  
// ================================= cart page area popup ========================================================
            $(".m-cart__delivery--options .delivery-messages p a").click(function(){
                  $(".m-modal-delivery-area").addClass("m-open-modal").css("opacity", "1");
                  $("html").addClass("prevent-scroll");
            });  
            $(".m-modal-delivery-area button.m-modal--close").click(function(){
                  $(".m-modal-delivery-area").removeClass("m-open-modal").css("opacity", "0");
                  $("html").removeClass("prevent-scroll");
            });  
            $('.m-modal-delivery-area').click(function(e) {             
                  if (!$(e.target).closest('.m-modal-delivery-area .m-modal--content-inner').length){
                      $(".m-modal-delivery-area").removeClass("m-open-modal").css("opacity", "0");
                     $("html").removeClass("prevent-scroll");
                  return false
                  }
            });
// ==========================================================================================================================
  

  // =============================Collection page filter (based on tag)========================
    $('#more-filter').on('change', function(event) {         
         $(`[data-value='yes']`).trigger("click");
    });


// =============================Header special mega menu==============
$('.m-sub-menu li[data-nav-title]').mouseenter(function(){
            $('.m-sub-menu li[data-nav-title]').removeClass('active');
            $(this).addClass('active');  
            $(".m-sub-menu-content li").removeClass("is_active")
            var activeTab = $(this).attr('data-nav-title'); 
            $(".m-sub-menu-content li[data-tab-content='" + activeTab + "']").addClass("is_active"); // Corrected selector and usage of single quotes
            return false;
});

  
  // ========================================================================================================
});

$(window).on("load", function() {  
         var hasVal = location.hash;
        if ( hasVal != "") {
                      if  ($("body").hasClass("cstm_page__terms-conditions")|| $("body").hasClass("cstm_page__a-account") || $("body").hasClass("cstm_page__returns-refunds") || $("body").hasClass("cstm_page__more-account")  || $("body").hasClass("cstm_page__home-delivery-collection") || $("body").hasClass("cstm_page__lay-bys-account")  ){
                                $(hasVal).find("[data-trigger]").trigger("click");
                                $('html, body').animate({
                                  scrollTop: $(hasVal).offset().top - 250
                                }, 1200);
                        }
                         else {
                            if($(hasVal).length && location.href.indexOf(hasVal) > -1){        
                                $('html, body').animate({
                                  scrollTop: $(hasVal).offset().top - 250
                                }, 1200);
                            }
                      }
        }
});


$( ".m-icon-box-section .m-button" ).on( "click", function() {
   var hasVal = $(this).attr("href");
      // console.log('hs --', hasVal)      
          $('html, body').animate({
            scrollTop: $(hasVal).offset().top - 250
          }, 100);      
} );

$( ".m-footer--bottom-menu a" ).on( "click", function(e) {
   var hasVal = $(this).attr("href").split("#")[1];
    $(".m-collapsible--content").height("0")
      $("#" + hasVal).find(".m-collapsible--content").height("auto")
          $('html, body').animate({
             scrollTop: $("#" + hasVal).offset().top - 250
          }, 100);      
} );



function Showpassword(button) {
  var x = document.querySelector('[name="customer[password]"]')  ;
  if (x.type === "password") {
    x.type = "text";
      button.textContent = "Hide Password";
  } else {
    x.type = "password";
    button.textContent = "Show Password";
  }
}

// ============================= Testing mode  ==========================================
 function cart_deals (e) {
       console.log("Function callled ===> cart_deals(); ")
       fetch('/cart.js', {
          method: 'GET',
          headers: {
          'Content-Type': 'application/json'
          }
      })
      .then(response => response.json()) 
      .then(cart => {
            console.log("Cart Object:", cart);
            const raw = JSON.stringify(cart);
            var settings = {
                    "url": "https://ackermans.commercebridge.tech/rest/v1/deals/find",
                    "method": "POST",
                    "timeout": 0,
                    "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer D31599216G16AD76EAF5E77CE4BD3EDF645B8A6B",
                    "Cookie": "PHPSESSID=etb20vhqr9415f3j71sa7imbk3"
                    },
                    "data": raw,
            };
            $.ajax(settings).done(function (response) {
                      console.log("Deal response", response)
               if (response.length > 0){
                  update_discount_attr (response);    
               }else{
                   remove_discount_attr();                 
               } 

            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.error("Request failed: " + textStatus, errorThrown);            
                console.log("An error occurred while processing your request. Please try again.");
            });
      })
      .catch(error => {
            console.error("Error fetching cart:", error); // Handle error fetching the cart
            
      });    
 }
function remove_discount_attr () {
// Data to be sent in the request
      const requestData = {
        attributes: {
            "discountIds": "",
            "Ackermans_Deals": ""
        }
      };
      
      fetch('/cart/update.js', {
        method: 'POST', 
        headers: {
            'Content-Type': 'application/json' 
        },
        body: JSON.stringify(requestData) // Convert JavaScript object to JSON string
      })
      .then(response => {
        if (!response.ok) {
            // Handle non-200 HTTP responses
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Parse JSON response
      })
      .then(data => {
          const this_cartDrawer = document.querySelector('m-cart-drawer') || document.querySelector('m-cart') ;
              if (this_cartDrawer.tagName.toLowerCase() === 'm-cart-drawer') {
                  this_cartDrawer.onCartDrawerUpdate();
                  this_cartDrawer.open();
              } else {
                  this_cartDrawer.onCartUpdate();
              }
      })
      .catch(error => {    
        console.error('Error:', error);
      });
}
function update_discount_attr(response) {
    const discountIdsArray = [];
    const ackermansDealsArray = [];
    response.forEach(item => {
        try {
            const parsedItem = JSON.parse(item); // Parse the JSON string
            // Collect discountIds and Ackermans_deals into arrays
            if (parsedItem.discountIds) {
                discountIdsArray.push(parsedItem.discountIds);
            }
            if (parsedItem.Ackermans_deals) {
                ackermansDealsArray.push(parsedItem.Ackermans_deals);
            }
        } catch (error) {
            console.error("Error parsing JSON:", error);
        }
    });
    const data = {
        attributes: {
            discountIds: discountIdsArray.length > 0 ? discountIdsArray : null,
            Ackermans_Deals: ackermansDealsArray.length > 0 ? JSON.stringify(ackermansDealsArray) : null
        }
    };
    // Make the API request to update the cart with the dynamic attributes
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data) // Send the updated data with dynamic attributes
    })
    .then(response => response.json())
    .then(data => {
        console.log('Success update_discount_attr :', data);
        const this_cartDrawer = document.querySelector('m-cart-drawer') || document.querySelector('m-cart');
        if (this_cartDrawer.tagName.toLowerCase() === 'm-cart-drawer') {
           this_cartDrawer.onCartDrawerUpdate();
           this_cartDrawer.open();
        } else {
              this_cartDrawer.onCartUpdate();
        }
    })
    .catch(error => {
        console.error('Error:', error);
    });
}







